import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { AppSelectors } from '@redux/AppRedux';

const { Option } = Select;

const transformCity = cityItem => ({
  key: cityItem,
  text: cityItem
});

function CitySearch(props) {
  const { cities, value, onChange } = props;
  const [data, setData] = useState(cities.map(transformCity));

  useEffect(() => {
    setData(cities.map(transformCity));
  }, [cities]);

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Cities"
      onChange={onChange}
      value={value}
    >
      {data.map(cityItem => (
        <Option key={cityItem.key}>{cityItem.text}</Option>
      ))}
    </Select>
  );
}

CitySearch.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  cities: PropTypes.array
};

const mapStateToProps = state => ({
  cities: AppSelectors.selectCities(state)
});

export default connect(
  mapStateToProps,
  {}
)(CitySearch);
